import { render, staticRenderFns } from "./edgeHost.vue?vue&type=template&id=98ca930c&scoped=true"
import script from "./edgeHost.vue?vue&type=script&lang=js"
export * from "./edgeHost.vue?vue&type=script&lang=js"
import style0 from "./edgeHost.vue?vue&type=style&index=0&id=98ca930c&prod&scoped=true&lang=scss"
import style1 from "./edgeHost.vue?vue&type=style&index=1&id=98ca930c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ca930c",
  null
  
)

export default component.exports